import { render, staticRenderFns } from "./DeliveryMethodsList.vue?vue&type=template&id=7b45c948&scoped=true"
import script from "./DeliveryMethodsList.vue?vue&type=script&lang=js"
export * from "./DeliveryMethodsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b45c948",
  null
  
)

export default component.exports